import { fetchLocalServices } from './apiClients/LocalhostApi';
import { getSessionStorage, getGlobal } from './apiClients/global';
export const CHIRP_SKIP_LOCAL_KEY = 'CHIRP_SKIP_LOCAL';
export const CHIRP_FORCE_401_KEY = 'CHIRP_FORCE_401';
let localServicesPromise = null;

// we aren't allowed enviro here due to npm-shim constraints
function matchesLocation(hostnamePattern, pathPrefix) {
  try {
    const global = getGlobal();
    if (!global.location) {
      return false;
    }
    const {
      hostname,
      pathname
    } = global.location;
    return hostnamePattern.test(hostname) && (pathPrefix === undefined || pathname.startsWith(pathPrefix));
  } catch (_unused) {
    return false;
  }
}
function isQA() {
  return matchesLocation(/qa\./);
}
function isGoggles() {
  return matchesLocation(/(tools|private|local)\.hubteam(qa)?\.com/, '/api');
}
function getSessionStorageFlag(key) {
  const sessionStorage = getSessionStorage();
  if (!sessionStorage || typeof sessionStorage.getItem !== 'function') {
    return false;
  }
  try {
    return sessionStorage.getItem(key) === 'true';
  } catch (_unused2) {
    return false;
  }
}
function getSkipLocalValue() {
  try {
    var _getSessionStorage;
    const raw = (_getSessionStorage = getSessionStorage()) === null || _getSessionStorage === void 0 ? void 0 : _getSessionStorage.getItem(CHIRP_SKIP_LOCAL_KEY);
    if (!raw) return null;
    if (raw === 'true') return true;
    const parsed = JSON.parse(raw);
    return Array.isArray(parsed) && parsed.every(i => typeof i === 'string') ? parsed : null;
  } catch (_unused3) {
    return null;
  }
}
function shouldSkipLocal(serviceName) {
  const value = getSkipLocalValue();
  if (value === true) {
    return true;
  }
  if (Array.isArray(value)) {
    return value.includes(serviceName);
  }
  return false;
}
function fetchLocalServicesCached() {
  if (!localServicesPromise) {
    localServicesPromise = fetchLocalServices().catch(() => []);
  }
  return localServicesPromise;
}
export async function resolveLocalRequest(serviceName) {
  const isAllowedHost = isQA() || isGoggles();
  if (!isAllowedHost) {
    return false;
  }
  if (shouldSkipLocal(serviceName)) {
    return false;
  }
  try {
    const services = await fetchLocalServicesCached();
    return services.some(s => s.name === serviceName);
  } catch (_unused4) {
    return false;
  }
}
export function shouldForce401() {
  return getSessionStorageFlag(CHIRP_FORCE_401_KEY);
}